import OpenGraphCard from '@components/primitives/Layout/HeaderComponents/OpenGraphCard'
import Head from 'next/head'
import TitleForHead from './TitleForHead'

/**
 * A component to instrument our defaults for the <head> tag of a page. Nextjs lets you declare many <Head> tags
 * in a page, and it will resolve them to be one.
 */
export const PageHeader = ({
  canonicalUrl,
  metaDescription,
  openGraphTitle,
  openGraphUrl,
  pageTitle,
}: {
  canonicalUrl: string
  metaDescription: string
  openGraphTitle: string
  openGraphUrl: string
  pageTitle: string
}) => {
  return (
    <>
      <Head>
        <meta content={metaDescription} name='description' />
        <link href={canonicalUrl} rel='canonical' />
      </Head>
      <TitleForHead title={pageTitle} />
      <OpenGraphCard
        description={metaDescription}
        imageDescription={metaDescription}
        imageUrl={openGraphUrl}
        title={openGraphTitle}
        url={canonicalUrl}
      />
    </>
  )
}
